export function createConfigurationApplied(data) {
    return {
        name: 'ConfigurationApplied',
        environments: ['device'],
        data: data
    };
}
//# sourceMappingURL=createConfigurationApplied.js.map